import { render, staticRenderFns } from "./MedicalLeaveCreate.vue?vue&type=template&id=7374f882"
import script from "./MedicalLeaveCreate.vue?vue&type=script&lang=js"
export * from "./MedicalLeaveCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports